<template id="warp_sim12">
    <div class="content1" style="font-size: 0.8rem;">
      <div style="overflow-y: auto;" :style="this.params.aduitflag == 1?'height: 300px;':'height: 400px;'">
        <div style="margin: 1rem;border: 1px solid #ededed;" v-if="params.tradetype == 0 || params.tradetype == 1">
          <div class="content-title">
            <span v-if="params.tradetype == 0">存款</span>
            <span v-if="params.tradetype == 1">提款</span>
          </div>
          <div class="content-top">
            <span style="flex: 1 1 0%;">交易編號 
              <span style="margin-left: 6%;">{{params.tradecode}}</span>
            </span>
            <span style="flex: 1 1 0%;">{{params.tradetype == 0?'存款':'提款'}}金額 
              <span style="margin-left: 6%;" :style="{color:params.tradetype==1?'#fa2c39':'#35c62e'}">{{params.tradestr}}</span>
              <img :src="require('../../../image/cunkuan.png')" style="margin-left: 3%;margin-bottom: 3px;" @click="setVisible = true" v-if="params.tradetype == 0 && items.whichoperator!=1">
              <handItem v-if='setVisible' @child='handfn' :record='items'></handItem>
            </span>
            <!-- <span style="flex: 1 1 0%;">貨幣種類 
              <span style="margin-left: 6%;">{{params.ccytype}}</span>
            </span> -->
          </div>
          <!-- <div>{{ params.tradetype != 0   }} {{ items.whichoperator != 1}}</div> -->
          <div v-if="params.tradetype != 0 || items.whichoperator == 1 " class="content-top" :style="{backgroundColor: params.tradetype != 0 || items.whichoperator == 1 ?'#fafafa':''}">
            <span style="flex: 1 1 0%;">銀行名稱 
              <span style="margin-left: 6%;">{{params.recipient_bankname}}</span>
            </span>
            <span style="flex: 1 1 0%;">銀行號碼
              <span style="margin-left: 6%;">{{params.recipient_bankcode}}</span>
            </span>
          </div>
          <div class="content-top"  :style="{backgroundColor: params.tradetype == 0 && items.whichoperator != 1 ?'#fafafa':''}">
            <span style="flex: 1 1 0%;">提交時間
              <span style="margin-left: 6%;">{{params.createtime}}</span>
            </span>
            <span style="flex: 1 1 0%;">備註信息 
              <span style="margin-left: 6%;">{{params.remark}}</span>
            </span>
          </div>
          <!-- 11111 -->
          <div  class="content-top" :style="{backgroundColor: params.tradetype != 0 || items.whichoperator == 1 ?'#fafafa':''}" v-if=" params.auditLogList.length>0">
            <span style="flex: 1 1 0%;">提交人員 
              <span style="margin-left: 6%;">{{params.auditLogList[0].submit_person}}</span>
            </span>
            <span style="flex: 1 1 0%;">審核人員
              <span style="margin-left: 6%;">{{params.auditLogList[0].audit_person}}</span>
            </span>
          </div>

        </div>
        <div style="margin: 1rem;border: 1px solid #ededed;" v-else>
          <div class="content-title">貨幣兌換</div>
          <div class="content-top">
            <span style="flex: 1 1 0%;">交易編號 
              <span style="margin-left: 6%;">{{params.tradecode}}</span>
            </span>
            <span style="flex: 1 1 0%; display: flex;">貨幣匯率
              <span style="margin-left: 6%;">
                <el-input v-model="params.rate" class="numrule" type="number" @input="exchange(params.rate)"  :disabled="this.params.rateflag != 1"/>
                <!-- {{params.rate}} -->
              </span>
            </span>
          </div>
          <div class="content-top" style="background-color:#fafafa;">
            <span style="flex: 1 1 0%;">賣出金額 
              <span style="margin-left: 6%;color:#fa2c39;">{{params.ccy_s}} {{params.price_s}}</span>
            </span>
            <span style="flex: 1 1 0%;">買入金額 
              <span style="margin-left: 6%;color:#35c62e;">{{params.ccy_b}} {{params.price_b}}</span>
            </span>
          </div>
          <div class="content-top" >
            <span style="flex: 1 1 0%;">提交時間 
              <span style="margin-left: 6%;">{{params.createtime}}</span>
            </span>
            <span style="flex: 1 1 0%;">交易日期 
              <span style="margin-left: 6%;">{{params.tradetime}}</span>
            </span>
          </div>
          <!-- 11111 -->
          <div class="content-top"  style="background-color:#fafafa;" v-if=" params.auditLogList.length>0">
            <span style="flex: 1 1 0%;">提交人員 
              <span style="margin-left: 6%;">{{params.auditLogList[0].submit_person}}</span>
            </span>
            <span style="flex: 1 1 0%;">審核人員 
              <span style="margin-left: 6%;">{{params.auditLogList[0].audit_person}}</span>
            </span>
          </div>

        </div>
        <div style="margin: 1rem;border: 1px solid #ededed;border-bottom: none;" v-if="params.auditLogList.length > 0">
          <div class="content-top" style="background-color:#fafafa;border-bottom: 1px solid #ededed;" v-for="(item,index) in params.auditLogList" :key="index">
            <span style="width:50%;flex-shrink: 0;">{{item.admin}}</span>
            <span style="flex: 1 1 0%; display: flex;">
              <span style="flex: 1 1 0%;">{{item.remark}}</span>
              <span style="width:50%;flex-shrink: 0;">{{item.aduittime}}</span>
            </span>
          </div>
          <!-- <div class="content_div" style="background-color:#fafafa;border-bottom: 1px solid #ededed;" v-for="(item,index) in params.auditLogList" :key="index">
            <span style="width:50%;flex-shrink: 0;">{{item.admin}}</span>
            <span style="display: flex;width: 100%;">
              <span style="width:100%;">{{item.remark}}</span>
              <span style="width:40%;flex-shrink: 0;text-align: right;">{{item.aduittime}}</span>
            </span>
          </div> -->
        </div>
      </div>

      <div style="border-top:1px solid #ededed;padding: 20px 30px; display: flex;" v-if="this.params.aduitflag == 1">
        <a-textarea :maxLength='200'  :autoSize="{minRows: 3, maxRows: 10}" style="width:60%;flex-shrink: 0;" v-model="auditContent" allow-clear />
        <div style="display:flex;align-items: center;width: 100%;justify-content: center;">
            <button class="btnOn" @click="btnOnClick(2)" >審核拒絕</button>
            <button class="btnOK" @click="btnOnClick(1)">審核通過</button>
        </div>
      </div>
    </div>
</template>

<script>
import handItem from './handItem'
import App from '@/assets/app.js';
export default {
  components: {
    handItem,
  },
  props: ["items"],
  data() {
    return {
      useradmin: this.$store.state.rolesdata.indexOf('useradmin') >= 0,
      params:{},
      auditContent:"",
      setVisible:false,
    };
  },
  mounted() {
    this.echoData();
    console.log(this.items);
  },
  methods: {
    echoData(){
			this.$ajax({
				method: "post",
				url: this.$api.getUserTradeAuditDetails,
				data: {
					aduitid:this.items.aduitid,
				},
			}).then((res) => {
				if (res.data.qmiscode == 1000) {
					this.params = res.data;
				} else {
					App.oTool.warningT(res.data.qmismsg);
				}
			});
		},
    Aduit(type){
      var price_b,rate;
      if (type == 1) {
        price_b = this.params.price_b;
        rate = this.params.rate;
      }
      this.$ajax({
        method: 'post',
        url: this.$api.newUserAduit,
        data: {
          aduitid: this.items.aduitid,
          token: this.$store.state.token,
          handle: type,
          remark: this.auditContent,
          rate:rate,
          price_b:price_b,
        }
      }).then(res => {
        if (res.data.qmiscode === 1000) {
          App.oTool.successT();
          this.echoData();
        } else {
          App.oTool.warningT(res.data.qmismsg);
        }
      })
    },
    btnOnClick(val){
      if (val == 1) {
        if (this.auditContent) {
          this.Aduit(val);
        }else{
          this.auditContent = '審核通過';
          this.Aduit(val);
        }
      }else{
        if (!this.auditContent) {
          App.oTool.warningT("請填寫備註信息");
        }else{
          this.Aduit(val);
        }
      }
    },
    handfn(){
      this.setVisible = false
      this.$emit('child', true)
    },
    exchange(val){
      let value = this.params.price_s.trim()
      if (value.indexOf(',') !== -1) {
        value = value.split(',').join('')
        // 防止输入非数字,第一位可为负号
      } else if (isNaN(value) && value !== '-') {
        value = ''
      }
      if (this.params.ccy_s == 'HKD' && val && val != 0) {
        var data = parseFloat(value / val).toFixed(3)
        // this.params.price_b = parseFloat(value / val).toFixed(2)
        // 获取整数部分
        const intPart = Math.trunc(data)
        // 整数部分处理，增加,
        const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
        // 预定义小数部分
        let floatPart = '.00'
        // 将数据分割为小数部分和整数部分
        const newArr = data.toString().split('.')
        if (newArr.length === 2) { // 有小数部分
          floatPart = newArr[1].toString() // 取得小数部分
          this.params.price_b = intPartFormat + '.' + floatPart
          // console.log(intPartFormat + '.' + floatPart);
          return
        }
        this.params.price_b = intPartFormat + floatPart
        // console.log(intPartFormat + floatPart);
        return   
      }else{
        // this.params.price_b = parseFloat(value * val).toFixed(2)
        var data = parseFloat(value * val).toFixed(3)
        // this.params.price_b = parseFloat(value / val).toFixed(2)
        // 获取整数部分
        const intPart = Math.trunc(data)
        // 整数部分处理，增加,
        const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
        // 预定义小数部分
        let floatPart = '.00'
        // 将数据分割为小数部分和整数部分
        const newArr = data.toString().split('.')
        if (newArr.length === 2) { // 有小数部分
          floatPart = newArr[1].toString() // 取得小数部分
          this.params.price_b = intPartFormat + '.' + floatPart;
          return
        }
        this.params.price_b = intPartFormat + floatPart;
        return   
      }
    }
  },
};
</script>
<style>
/* @import url("//unpkg.com/element-ui@2.15.6/lib/theme-chalk/index.css"); */
</style>

<style lang="scss" scoped>

  .content_div{
    width: 100%;
    background: #ffffff;
    color: #000000;
    display: flex;
    padding: 18px 20px;
  }
	.content1{
		padding-bottom: 1rem;
		border-radius: 0 0 10px 10px;
		padding: 1rem;
		background-color: #fff;
		margin-bottom: 1rem;
		min-height: 50px;
	}
  .content-title{
    width: 100%;
    height: 60px;
    background: #fafafa;
    color: #0c8b97;
    line-height: 60px;
    padding: 0 20px;
    font-weight: 600;
	}
  .content-top{
		width: 100%;
		height: 60px;
		background: #ffffff;
		color: #000000;
		line-height: 60px;
		display: flex;
		padding: 0 20px;
	}
  .btnOn{
    background: #ed4849;
    border: none;
    border-radius: 4px;
    color: #ffffff;
    padding: 10px 20px;
    margin-left: 10%;
  }
  .btnOK{
    background: #0c8b97;
    border: none;
    border-radius: 4px;
    color: #ffffff;
    padding: 10px 20px;
    margin-left: 10%;
  }

::v-deep .numrule input::-webkit-outer-spin-button,
::v-deep .numrule input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
::v-deep .numrule input[type="number"] {
  -moz-appearance: textfield !important;

}
::v-deep .numrule input{
  height: 1.75rem;
}
::v-deep .numrule .el-input__inner:focus{
  height: 1.75rem;
  line-height: 1.75rem;
  border-color: #0c8b97;
}

</style>

